/** Keystone's mark: a keystone in the foreground ink on a 24 px box, an image like every kit graphic. The tab icon (v2/index.html) is the same drawing. */
import { paint } from "./icons/paint";
import { FOREGROUND } from "./icons/palette";

const SRC = paint({ w: 24, h: 24, grid: [18, 18], layers: [{ d: "M1.5 2.5h15L13 15.5H5z", fill: FOREGROUND }] });

export function Mark() {
  return <img src={SRC} alt="" width={24} height={24} className="block size-6" />;
}
